import { notification } from "antd";
import { useMutation } from "react-query";
import { isError } from "utils/api/models/api-response";
import { ReadOne } from "services/notifications/index";
import i18next from "i18next";

export default function ReadOneNotification() {
  return {
    ...useMutation(ReadOne, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم تمييز الاشعار كمقروء"
                : "Notification marked as read",
          });
        }
      },
    }),
  };
}
